import React, { useEffect, useState } from 'react';
import API from '../api';
import { useTranslation } from 'react-i18next';

function CustomerForm({ customer, onSubmit }) {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [address, setAddress] = useState('');
  const [whatsappNumber, setWhatsappNumber] = useState('');
  const [notes, setNotes] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    if (customer) {
      setName(customer.name);
      setPhone(customer.phone);
      setEmail(customer.email || '');
      setAddress(customer.address || '');
      setWhatsappNumber(customer.whatsapp_number || '');
      setNotes(customer.notes || '');
    } else {
      setName('');
      setPhone('');
      setEmail('');
      setAddress('');
      setWhatsappNumber('');
      setNotes('');
    }
  }, [customer]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = { name, phone, email, address, whatsapp_number: whatsappNumber, notes };
    if (customer) {
      API.put(`customers/${customer.id}/`, data).then(onSubmit);
    } else {
      API.post('customers/', data).then(onSubmit);
    }
    setName('');
    setPhone('');
    setEmail('');
    setAddress('');
    setWhatsappNumber('');
    setNotes('');
  };

  return (
    <form onSubmit={handleSubmit} style={{display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '20px'}}>
      <input placeholder={t('Name')} value={name} onChange={e => setName(e.target.value)} required />
      <input placeholder={t('Phone')} value={phone} onChange={e => setPhone(e.target.value)} required />
      <input placeholder={t('Email')} type="email" value={email} onChange={e => setEmail(e.target.value)} />
      <textarea placeholder={t('Address')} value={address} onChange={e => setAddress(e.target.value)} />
      <input placeholder={t('WhatsApp Number')} value={whatsappNumber} onChange={e => setWhatsappNumber(e.target.value)} />
      <textarea placeholder={t('Notes')} value={notes} onChange={e => setNotes(e.target.value)} />
      <button type="submit">{customer ? t('Update Customer') : t('Add Customer')}</button>
    </form>
  );
}

export default CustomerForm;
